export enum CHART_EVENT_IDS {
  CHART_EXPORTED = 'Chart Exported',
  CHART_UPDATED = 'Chart Updated',
  CHART_FILTERED = 'Chart Filtered',
  DASHBOARD_FILTERED = 'Dashboard Filtered',
  CHART_REDRAWN = 'Chart Redrawn',
  CHART_VIEW_CHANGED = 'Chart View Changed',
  CHART_GROUPED = 'Chart Grouped',
  METRIC_TOOLTIP_VIEWED = 'Metric Tooltip Viewed',
  CHART_DOWNLOADED = 'Chart Downloaded',
}

export enum BULK_UPLOAD_EVENT_IDS {
  BULK_UPLOAD_STARTED = 'Bulk Upload Started',
  BULK_ACTIVATIONS_REVIEWED = 'Bulk Activations Reviewed',
  BULK_DEACTIVATIONS_REVIEWED = 'Bulk Deactivations Reviewed',
  BULK_CHANGES_CONFIRMED = 'Bulk Changes Confirmed',
  CSV_IMPORT_FAILED = 'CSV Import Failed',
  BULK_CHANGES_CANCELLED = 'Bulk Changes Cancelled',
  BULK_UPLOAD_SUCCESS = 'Bulk Upload Success',
  BULK_UPLOAD_FAILED = 'Bulk Upload Failed',
}

export enum FILE_UPLOAD_EVENT_IDS {
  OPR_REPORT_SUBMITTED = 'OPR Report Submitted',
  OPR_FILE_UPLOAD_UPDATED = 'OPR File Upload Updated',
  OPR_REPORT_SENT = 'OPR Report Sent',
  REPORTER_HUB_FILE_UPLOAD_UPDATED = 'Reporter Hub File Upload Updated',
}

export enum REPORT_TRANSLATION_EVENT_IDS {
  REPORT_TRANSLATED = 'Report Translated',
}

export enum CHAT_TRANSLATION_OPTION_UPDATED_EVENT_IDS {
  CHAT_TRANSLATION_OPTION_UPDATED = 'Chat Translation Option Updated',
}

export enum REPORTING_EVENT_IDS {
  REPORTER_PORTAL_ACCOUNT_ACTIVATION_STEP_CHANGED = 'Vault Account Activation Step Changed',
  SLACK_ACCOUNT_CONNECTION_STEP_COMPLETED = 'Slack Account Connection Step Completed',
}

export enum CASE_LINKING_EVENT_IDS {
  LINK_DETAILS_VIEWED = 'Link Details Viewed',
  LINK_NAVIGATION_CLICKED = 'Link Navigation Clicked',
}

export enum CASE_IMPORT_EVENT_IDS {
  CASE_IMPORT_ENTERED = 'Case import entered',
  CASE_IMPORT_REVIEW_STARTED = 'Case import review started',
  CASE_IMPORT_CSV_VALIDATION_FAILED = 'Case import csv validation failed',
  CASE_IMPORT_PROCESSING_FAILED_TO_START = 'Case import processing failed to start',
  CASE_IMPORT_HISTORY_VIEWED = 'Case import history viewed',
  CASE_IMPORT_HISTORY_REPORT_OPENED = 'Case import history report opened',
  CASE_IMPORT_REVIEW_OPENED = 'Case import review opened',
  CASE_IMPORT_CONFIRMED = 'Case import confirmed',
  CASE_IMPORT_CANCELLED = 'Case import cancelled',
  CASE_IMPORT_FLOW_EXITED = 'Case import flow exited',
}
